var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 209,
    viewBox: "0 0 414 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_210)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_237_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 406C315.8 406 404 317.8 404 209C404 100.2 315.8 12 207 12C98.1999 12 10 100.2 10 209C10 317.8 98.1999 406 207 406Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 405.5C315.524 405.5 403.5 317.524 403.5 209C403.5 100.476 315.524 12.5 207 12.5C98.476 12.5 10.5 100.476 10.5 209C10.5 317.524 98.476 405.5 207 405.5Z",
    stroke: "#D8BE8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_237_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 359C289.843 359 357 291.843 357 209C357 126.157 289.843 59 207 59C124.157 59 57 126.157 57 209C57 291.843 124.157 359 207 359Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 358.5C289.567 358.5 356.5 291.567 356.5 209C356.5 126.433 289.567 59.5 207 59.5C124.433 59.5 57.5 126.433 57.5 209C57.5 291.567 124.433 358.5 207 358.5Z",
    stroke: "#D8BE8D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_237_210",
    x: 0,
    y: 0,
    width: 414,
    height: 414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_237_210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_237_210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_237_210",
    x: 47,
    y: 47,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_237_210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_237_210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 209,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.32e0ead9a275f830e22d7db8fd6f8008.svg";
export { ForwardRef as ReactComponent };